<template>
  <el-dialog
    :close-on-click-modal="false"
    title="行驶证上传"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section>
      <el-alert :closable="false" :title="warning" type="warning" />
      <img class="tmplImg" src="~images/archives/drivingLicensePic.png" />
      <qx-custom-form v-if="showVehicleClass" :noSubBtn="true" ref="baseForm" :formData="baseForm">
        <section slot="importBtn">
          <el-button @click="chooseFile" style="width: 120px;">选择文件</el-button>
        </section>
      </qx-custom-form>
      <div class="btnBox" v-else>
        导入文件：
        <el-button @click="chooseFile">选择文件</el-button>
      </div>
      <div class="filename" v-if="fileData">{{ fileData.name }}</div>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub" :loading="subLoading">上传</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  importPost,
  getEnumList,
} from 'api';
export default {
  props: {
    bizCodes: {
      type: String,
    },
    warning: {
      type: String,
      default: '温馨提示：针对未上传行驶证照片的司机，请将他们的行驶证正本的照片打成一个压缩包，压缩包格式支持：RAR、ZIP，图片格式支持：BMP、JPG、GIF、PNG',
    },
    // 是否显示车辆类型，自有车图片导入时候使用
    showVehicleClass: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      fileData: null,
      baseForm: {
        // 车辆种类
        vehicleClassOptions: [],
        inline: true,
        form: [
          {
            label: '导入文件',
            value: 'importBtn',
            slot: true,
            width: '120px',
          },
          {
            label: '车辆类型',
            value: 'vehicleClass',
            type: 'select',
            default: '1',
            width: '120px',
          },
        ],
      },
    };
  },
  methods: {

    downloadTmpl (url) {
      window.open(url);
    },

    chooseFile () {
      let domInput = document.createElement('input');
      domInput.setAttribute('type', 'file'); // 设置为上传文件
      domInput.setAttribute('accept', 'xlsx'); // 限制选择的文件
      domInput.setAttribute('multiple', false); // 设置可否为多选
      domInput.onchange = async () => {
        this.fileData = domInput.files[0];
        domInput = null;
      };
      domInput.click();
    },

    async getVehicleClass () {
      if (!this.baseForm.vehicleClassOptions.length) {
        // 如果没有拉到枚举，请求接口获取
        const enumsList = await getEnumList({
          codeType: 'VEHICLE_CLASS',
        });
        for (let item of enumsList[0]) {
          if (item.value !== '3') {
            // 这里下拉要屏蔽临时外调车
            this.baseForm.vehicleClassOptions.push(item);
          }
        }
      } else {
        // 如果已经拉到了枚举，默认选择第一个
        this.$refs.baseForm.setVal('vehicleClass', this.baseForm.vehicleClassOptions[0].value);
      }
    },

    /**
     * @param {Object} arr 数组id
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (arr) {
      this.dialogFormVisible = true; // 打开弹窗
      this.fileData = null;
      this.originData = arr;
      if (this.showVehicleClass) {
        this.getVehicleClass();
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub () {
      if (!this.fileData) {
        this.$message({
          type: 'warning',
          message: '请选择导入的压缩包文件',
        });
        return;
      }
      this.subLoading = true;
      const params = {
        bizCodes: this.bizCodes,
        file: this.fileData,
        otherParam: {},
      };
      if (this.showVehicleClass) {
        const vehicleClass = await this.$refs.baseForm.getVal('vehicleClass');
        params.otherParam.vehicleClass = vehicleClass;
      }
      const res = await importPost({
        data: params,
        fileData: {
          bizCode: this.bizCodes,
          bizName: '行驶证正本导入',
          id: 69,
          otherParam: {
            bizCode: this.bizCodes,
          },
        },
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-alert__content {
  line-height: 24px;
}
.tmplImg {
  width: 100%;
  margin-bottom: 16px;
}
.tmplFile {
  margin-bottom: 16px;
  color: #999;
}
.btnBox {
  color: #999;
  margin-bottom: 16px;
}
.filename {
  color: #999;
  padding-left: 72px;
}
</style>
